export type PageRoles = keyof typeof ROLES;
export type PagePermissions = (typeof ROLES)[PageRoles][number];

const ROLES = {
  "Admin de Dominio": [
    "view:organization",
    "create:suborganization",
    "edit:suborganization",
    "delete:suborganization",
    "create:userOrganization",
    "delete:userOrganization",
    "view:roles",
    "create:role",
    "edit:role",
    "delete:role",
    "create:roleApps",
    "delete:roleApps",
    "create:roleUsers",
    "delete:roleUsers",
    "view:plans",
    "create:plans",
    "edit:plans",
    "delete:plans",
    "view:suscriptions",
    "view:userSuscriptions",
    "create:suscriptions",
    "delete:suscriptions",
    "edit:suscriptions",
    "view:users",
    "create:users",
    "edit:users",
    "delete:users",
    "view:reports",
    "view:admin",
    "view:dashboard",
    "view:oas"
  ],
  "Admin de Organización": [
    "view:ownOrganization",
    "create:suborganization",
    "edit:suborganization",
    "delete:suborganization",
    "create:userOrganization",
    "delete:userOrganization",
    "view:ownRoles",
    "create:role",
    "edit:role",
    "delete:role",
    "create:roleApps",
    "delete:roleApps",
    "create:roleUsers",
    "delete:roleUsers",
    "view:ownPlans",
    "view:ownSuscriptions",
    "view:userSuscriptions",
    "view:ownUsers",
    "create:users",
    "edit:users",
    "delete:users",
    "view:ownReports",
    "view:admin",
    "view:ownDashboard",
    "view:ownOas"
  ],
  Profesor: [],
} as const;

export function hasPermission(
  roles: {
    id_rol: string;
    rol: string;
  }[],
  permissions: PagePermissions | PagePermissions[]
) {
  // Si es un solo permiso, lo convertimos en un array
  const permisosRequeridos = Array.isArray(permissions)
    ? permissions
    : [permissions];

  // Función auxiliar para verificar si el usuario tiene al menos uno de los permisos requeridos
  const tienePermiso = (rol: PageRoles) =>
    (ROLES[rol] as readonly PagePermissions[]).some((permiso) =>
      permisosRequeridos.includes(permiso)
    );

  /* TEMPORALMENTE evaluamos primero el Profesor */
  /* if (roles?.some((role) => role.rol === "Profesor")) {
    return tienePermiso("Profesor");
  } */

  /* TEMPORALMENTE evaluamos primero el Admin de Organizacion */
  /* if (roles?.some((role) => role.rol === "Admin de Organización")) {
    return tienePermiso("Admin de Organización");
  } */

  // Primero buscamos que sea admin de dominio
  if (roles?.some((role) => role.rol === "Admin de Dominio")) {
    return tienePermiso("Admin de Dominio");
  }

  // Luego buscamos al admin de organizacion
  if (roles?.some((role) => role.rol === "Admin de Organización")) {
    return tienePermiso("Admin de Organización");
  }

  // De últimas buscamos al profesor
  else {
    return tienePermiso("Profesor");
  }
}
